import { Plugin } from '@ckeditor/ckeditor5-core';
import { Widget } from '@ckeditor/ckeditor5-widget';
import InsertSkillsCommand from './skills-command';
export default class SkillsEditing extends Plugin {
    static get requires() {
        return [Widget];
    }
    init() {
        this._defineSchema();
        this._defineConverters();
        this.editor.commands.add('insertSkills', new InsertSkillsCommand(this.editor));
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('skills', {
            isObject: true,
            allowContentOf: '$root',
            allowWhere: '$block',
        });
        schema.register('skillItem', {
            isLimit: true,
            allowContentOf: '$block',
            allowIn: 'skills',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.elementToElement({
            model: 'skills',
            view: {
                name: 'div',
                classes: 'skills',
            },
        });
        conversion.elementToElement({
            model: 'skillItem',
            view: {
                name: 'div',
                classes: 'skill__item',
            },
        });
    }
}
